// Reexport the native module.
import ExpoAdapterIterableModule from './ExpoAdapterIterableModule';

export default ExpoAdapterIterableModule;
